<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3">Listado de Pagos</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pb-3">
        <v-btn
          :disabled="loading"
          color="primary"
          small
          outlined
          class="text-white mt-4"
          @click="sendSyncPayments()"
        >
          <i class="mdi mdi-sync me-1"></i>
          Sincronizar Pagos
        </v-btn>
        <v-btn
          class="mt-4 mx-4"
          color="success text-white"
          small
          :disabled="!payments.items.length"
          @click="downloadExcelReportPayments"
        >
          <!-- icon excel -->
          <v-icon small class="mr-1"> mdi-file-excel </v-icon>
          Exportar
        </v-btn>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12" class="mb-2">
        <v-text-field
          label="Búsqueda"
          v-model="filters.filter"
          clearable
          class="mt-3"
          placeholder="Búsqueda"
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-autocomplete
          v-model="filters.items"
          class="mt-3"
          :items="[5, 10, 15, 20, 25, 100]"
          label="Items por página"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <v-autocomplete
          v-model="filters.is_paid"
          class="mt-3"
          :items="listStatusPayment"
          label="Filtrar por Estatus"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="pt-0 mb-3">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_start"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_start_formatted"
              prepend-icon="mdi-calendar"
              readonly
              hide-details
              label="Fecha creación"
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_start"
            scrollable
            locale="es"
            @input="datepicker_menu_start = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="4" sm="12" class="pt-0 mb-3">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_end"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_end_formatted"
              prepend-icon="mdi-calendar"
              readonly
              label="Fecha vencimiento"
              v-bind="attrs"
              v-on="on"
              clearable
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_end"
            scrollable
            locale="es"
            clearable
            @input="datepicker_menu_end = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-2">
        <v-data-table
          :page.sync="filters.page"
          :headers="wrappedTableHeaders"
          :items="payments.items ? payments.items : []"
          item-key="id"
          :items-per-page="filters.items"
          class="elevation-1"
          mobile-breakpoint="993"
          hide-default-footer
          :loading="loading"
          disable-sort
          no-data-text="No hay Datos para Mostrar"
          loading-text="Cargando Pagos... Espere Por favor"
        >
          <template v-slot:header.code>
            <div
              class="d-inline-flex align-center"
              style="cursor: pointer; width: 100%"
              @click="toggleSort('code')"
            >
              <span>N° de Factura</span>
              <v-icon
                small
                class="ml-1"
                :color="sort.by === COLUMN_TO_BACKEND.code ? 'primary' : ''"
              >
                {{ sortIcon('code') }}
              </v-icon>
            </div>
          </template>

          <template v-slot:header.issueDate>
            <div
              class="d-inline-flex align-center"
              style="cursor: pointer; width: 100%"
              @click="toggleSort('issueDate')"
            >
              <span>Fecha Factura</span>
              <v-icon
                small
                class="ml-1"
                :color="sort.by === COLUMN_TO_BACKEND.issueDate ? 'primary' : ''"
              >
                {{ sortIcon('issueDate') }}
              </v-icon>
            </div>
          </template>

          <template v-slot:header.dueDate>
            <div
              class="d-inline-flex align-center"
              style="cursor: pointer; width: 100%"
              @click="toggleSort('dueDate')"
            >
              <span>Fecha Vencimiento</span>
              <v-icon
                small
                class="ml-1"
                :color="sort.by === COLUMN_TO_BACKEND.dueDate ? 'primary' : ''"
              >
                {{ sortIcon('dueDate') }}
              </v-icon>
            </div>
          </template>

          <template v-slot:header.amount>
            <div
              class="d-inline-flex align-center"
              style="cursor: pointer; width: 100%"
              @click="toggleSort('amount')"
            >
              <span>Monto Total</span>
              <v-icon
                small
                class="ml-1"
                :color="sort.by === COLUMN_TO_BACKEND.amount ? 'primary' : ''"
              >
                {{ sortIcon('amount') }}
              </v-icon>
            </div>
          </template>

          <template v-slot:header.project>
            <div
              class="d-inline-flex align-center"
              style="cursor: pointer; width: 100%"
              @click="toggleSort('project')"
            >
              <span>Proyecto</span>
              <v-icon
                small
                class="ml-1"
                :color="sort.by === COLUMN_TO_BACKEND.project ? 'primary' : ''"
              >
                {{ sortIcon('project') }}
              </v-icon>
            </div>
          </template>

          <template v-slot:header.csiAllowed>
            <div
              class="d-inline-flex align-center"
              style="cursor: pointer; width: 100%"
              @click="toggleSort('csiAllowed')"
            >
              <span>Posee Convenio</span>
              <v-icon
                small
                class="ml-1"
                :color="sort.by === COLUMN_TO_BACKEND.csiAllowed ? 'primary' : ''"
              >
                {{ sortIcon('csiAllowed') }}
              </v-icon>
            </div>
          </template>

          <template v-slot:header.status>
            <div
              class="d-inline-flex align-center"
              style="cursor: pointer; width: 100%"
              @click="toggleSort('status')"
            >
              <span>Estado Pago</span>
              <v-icon
                small
                class="ml-1"
                :color="sort.by === COLUMN_TO_BACKEND.status ? 'primary' : ''"
              >
                {{ sortIcon('status') }}
              </v-icon>
            </div>
          </template>
          <template v-slot:item.code="{ item }">
            <div class="d-flex align-items-center justify-content-end">
              <v-chip class="primary">
                {{ item.code }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.business_name="{ item }">
            <div class="text-left">
              {{ item.business_name }}
            </div>
          </template>
          <template v-slot:item.rut="{ item }">
            <div class="text-right">
              {{ item.rut }}
            </div>
          </template>
          <template v-slot:item.project="{ item }">
            <div class="text-left">
              {{ item.project }}
            </div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div class="text-right">
              {{
                item.amount
                  ? `$ ${item.amount.toLocaleString("cl-CL", {
                      currency: "CLP",
                    })}`
                  : 0
              }}
            </div>
          </template>
          <template v-slot:item.issueDate="{ item }">
            <span v-if="item.issueDate != null">{{
              formatDateToHuman(item.issueDate)
            }}</span>
          </template>
          <template v-slot:item.dueDate="{ item }">
            <span v-if="item.dueDate != null">{{
              formatDateToHuman(item.dueDate)
            }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  :color="item.status ? 'green' : 'warning'"
                  v-bind="attrs"
                  v-on="on"
                  class="text-white"
                >
                  {{ item.status ? "Pagada" : "Pendiente" }}
                </v-chip>
              </template>
              <span>{{ item.status ? "Pagada" : "Pendiente" }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="filters.page"
            :length="totalPages"
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatDateMomentToHumanAndAddDay } from "@/helpers/common";
import roles from "@/mixins/roles";
import { authUsuarioComputed } from "@/state/helpers";
import { exportExcelFileFromArrayObjects } from "@/helpers/xlsx";
import moment from "moment";

/**
 * Mapa de traducción entre la columna del `v-data-table` y el campo
 * que espera el backend para ordenar.
 * @constant {Readonly<Record<string, string>>}
 */
const COLUMN_TO_BACKEND = Object.freeze({
  code: "folio_number",
  issueDate: "initial_date",
  dueDate: "due_date",
  amount: "total",
  project: "project",
  status: "is_paid",
  csiAllowed: "csiAllowed",
});

/**
 * Ordenamiento inicial aplicado al cargar el componente: "Fecha Factura"
 * (más recientes primero).
 * @constant {Readonly<{ by: string, order: string }>}
 */
const INITIAL_SORT = Object.freeze({
  by: COLUMN_TO_BACKEND.issueDate,
  order: "desc",
});

/**
 * Tiempo de espera (ms) para agrupar pulsaciones consecutivas en la búsqueda.
 * @constant {number}
 */
const SEARCH_DEBOUNCE_MS = 400;

/**
 * Cantidad de registros solicitados por página por defecto.
 * @constant {number}
 */
const DEFAULT_PAGE_SIZE = 10;

export default {
  mixins: [roles],
  data() {
    return {
      /** @type {boolean} Indica que hay una petición de datos en curso. */
      loading: false,
      /** @type {boolean} Indica que una acción puntual (sincronizar/exportar) está en curso. */
      loadingActions: false,
      /** @type {number} Token incremental para descartar respuestas obsoletas. */
      requestToken: 0,
      /** @type {?ReturnType<typeof setTimeout>} Temporizador de debounce activo. */
      debounce: null,
      datepicker_menu_start: false,
      datepicker_menu_end: false,
      listStatusPayment: [
        {
          text: "Todos",
          value: null,
        },
        {
          text: "Pagada",
          value: true,
        },
        {
          text: "Pendiente",
          value: false,
        },
      ],
      /**
       * Estado de los filtros ligados a la interfaz.
       * @type {{
       *   page: number, items: number, filter: string,
       *   is_paid: (boolean|null), date_start: (string|null), date_end: (string|null)
       * }}
       */
      filters: {
        page: 1,
        items: DEFAULT_PAGE_SIZE,
        filter: "",
        is_paid: null,
        date_start: null,
        date_end: null,
      },
      /**
       * Estado de ordenamiento activo. Inicia ordenado por "Fecha Factura"
       * descendente (más recientes primero).
       * @type {{ by: string, order: string }}
       */
      sort: {
        by: INITIAL_SORT.by,
        order: INITIAL_SORT.order,
      },
      tableHeaders: [
        {
          value: "code",
          text: "N° de Factura",
          sortable: false,
          align: "start",
          width: "8%",
        },
        {
          value: "issueDate",
          sortable: false,
          align: "start",
          text: "Fecha Factura",
          width: "8%",
        },
        {
          value: "dueDate",
          sortable: false,
          align: "start",
          text: "Fecha Vencimiento",
          width: "10%",
        },
        {
          value: "amount",
          text: "Monto Total",
          sortable: false,
          align: "start",
          width: "9%",
        },
        {
          value: "project",
          text: "Proyecto",
          align: "start",
          sortable: false,
          width: "22%",
        },
        {
          value: "rut",
          text: "RUT",
          align: "start",
          sortable: false,
          width: "10%",
        },
        {
          value: "business_name",
          text: "Razón Social",
          align: "start",
          sortable: false,
          width: "17%",
        },
        {
          value: "csiAllowed",
          sortable: false,
          align: "start",
          text: "Posee Convenio",
          width: "8%",
        },
        {
          value: "status",
          sortable: false,
          align: "end",
          text: "Estado Pago",
          width: "8%",
        },
      ],
    };
  },
  mounted() {
    this.getPaymentsData();
  },
  beforeDestroy() {
    clearTimeout(this.debounce);
  },
  methods: {
    ...mapActions({
      syncPayments: "payment/syncPayments",
      getAllPayments: "payment/getAllPayments",
    }),

    /**
     * Construye el objeto de consulta (query params) que se envía al backend
     * a partir del estado actual de filtros, paginación y ordenamiento.
     * Omite los valores vacíos para no sobrescribir los valores por defecto del backend.
     *
     * @param {Object} [extra={}] Propiedades adicionales a fusionar en la consulta (p. ej. `export`).
     * @returns {Object} Payload listo para `getAllPayments`.
     */
    buildQuery(extra = {}) {
      const { filter, is_paid, date_start, date_end, items, page } = this.filters;
      const { by, order } = this.sort;

      return {
        page,
        items,
        general_filter: filter || undefined,
        is_paid: is_paid !== null ? is_paid : undefined,
        since: date_start ? `${date_start}` : undefined,
        since_due: date_end ? `${date_end}` : undefined,
        sort_by: by || undefined,
        sort_order: order || undefined,
        ...extra,
      };
    },

    /**
     * Alterna el ordenamiento de una columna entre `asc` y `desc`.
     * La primera vez que se ordena una columna se aplica `asc`; los clics
     * siguientes alternan la dirección.
     *
     * @param {string} column Valor (`value`) de la columna en `tableHeaders`.
     * @returns {void}
     */
    toggleSort(column) {
      const backendKey = COLUMN_TO_BACKEND[column] || column;

      if (this.sort.by !== backendKey) {
        this.sort.by = backendKey;
        this.sort.order = "asc";
      } else {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      }

      this.resetPageAndFetch();
    },

    /**
     * Restablece la paginación a la primera página y solicita los datos,
     * garantizando una única petición: si la página cambia, el watcher de
     * `filters.page` se encarga del fetch; si ya estamos en la 1, se solicita
     * aquí directamente.
     *
     * @param {Object} [params={}] Opciones de la petición.
     * @param {boolean} [params.debounced=false] Si es `true`, aplica *debounce* (usado por la búsqueda).
     * @returns {void}
     */
    resetPageAndFetch({ debounced = false } = {}) {
      if (this.filters.page !== 1) {
        this.filters.page = 1;
      } else {
        this.getPaymentsData({ debounced });
      }
    },

    /**
     * Devuelve el icono de Material Design correspondiente al estado de
     * ordenamiento de una columna.
     *
     * @param {string} column Valor (`value`) de la columna en `tableHeaders`.
     * @returns {string} Nombre del icono (`mdi-arrow-up`, `mdi-arrow-down` o `mdi-unfold-more-horizontal`).
     */
    sortIcon(column) {
      const backendKey = COLUMN_TO_BACKEND[column] || column;
      if (this.sort.by !== backendKey) return "mdi-unfold-more-horizontal";
      return this.sort.order === "asc" ? "mdi-arrow-up" : "mdi-arrow-down";
    },

    /**
     * Sincroniza los pagos contra el backend y refresca el listado.
     * @returns {Promise<void>}
     */
    async sendSyncPayments() {
      this.loadingActions = true;
      try {
        const resp = await this.syncPayments();
        if (resp && (resp.status === 200 || resp.status === 201)) {
          await this.getPaymentsData();
        } else {
          this.showError("No se pudo sincronizar los pagos");
        }
      } catch (e) {
        this.showError("Error al sincronizar los pagos");
      } finally {
        this.loadingActions = false;
      }
    },

    /**
     * Obtiene el listado de pagos aplicando los filtros, paginación y orden actuales.
     * Aplica un pequeño *debounce* sólo cuando se invoca desde la búsqueda.
     *
     * @param {Object} [params={}] Opciones de la petición.
     * @param {boolean} [params.debounced=false] Si es `true`, retarda la petición para agrupar pulsaciones.
     * @param {number} [params.page] Página a solicitar; si se omite se usa la actual.
     * @returns {Promise<void>}
     */
    async getPaymentsData({ debounced = false, page } = {}) {
      if (typeof page === "number") {
        this.filters.page = page;
      }

      clearTimeout(this.debounce);

      const token = ++this.requestToken;
      const run = async () => {
        this.loading = true;
        try {
          await this.getAllPayments(this.buildQuery());
        } catch (e) {
          if (token === this.requestToken) {
            this.showError("Error al cargar los pagos");
          }
        } finally {
          if (token === this.requestToken) {
            this.loading = false;
          }
        }
      };

      if (debounced) {
        this.debounce = setTimeout(run, SEARCH_DEBOUNCE_MS);
      } else {
        await run();
      }
    },

    /**
     * Descarga el listado de pagos en formato Excel respetando los filtros activos.
     * @returns {Promise<void>}
     */
    async downloadExcelReportPayments() {
      this.loadingActions = true;
      try {
        const resp = await this.getAllPayments(
          this.buildQuery({ items: this.payments.total_items, export: true })
        );
        if (resp && resp.status === 200) {
          this.buildAndDownloadExcel(resp.data);
        } else {
          this.showError(
            resp && resp.data && resp.data.detail
              ? resp.data.detail
              : "Ha ocurrido un error en el servidor, por favor intenta nuevamente mas tarde"
          );
        }
      } catch (e) {
        this.showError("Error al exportar los pagos");
      } finally {
        this.loadingActions = false;
      }
    },

    /**
     * Transforma la respuesta del backend y genera el archivo Excel.
     * @param {{ items: Object[] }} data Respuesta cruda del backend.
     * @returns {*} Resultado de la exportación.
     */
    buildAndDownloadExcel(data) {
      const payments = (data.items || []).map((item) => {
        const initial_date = moment(item.initial_date).add(1, "day").toDate();
        const due_date = moment(item.due_date).add(1, "day").toDate();
        return {
          "N° de Factura": item.folio_number,
          "Fecha Factura": initial_date,
          "Fecha Vencimiento": due_date,
          "Monto Total": item.total,
          Proyecto: item.project ? item.project.name : "-",
          RUT: (item.rut || "").replace(/C$/, ""),
          "Convenio": this.mapCsiAllowed(item.project && item.project.csiAllowed),
          "Razón Social": item.name,
          "Estado Pago": item.is_paid ? "Pagado" : "Pendiente",
        };
      });

      return exportExcelFileFromArrayObjects(
        payments,
        "Pagos",
        `listado_pagos_${moment().format("DD-MM-YYYY")}.xlsx`
      );
    },

    mapCsiAllowed(value) {
      if (value == null || value === '') return 'No'
      const normalized = String(value).trim().toUpperCase()
      const isTrue = normalized === 'T' || normalized === 'TRUE' || normalized === '1' || normalized === 'S' || normalized === 'SÍ'
      return isTrue ? 'Sí' : 'No'
    },

    /**
     * Formatea una fecha al formato humano (agregando un día).
     * @param {string|Date} date Fecha a formatear.
     * @returns {string} Fecha formateada.
     */
    formatDateToHuman(date) {
      return formatDateMomentToHumanAndAddDay(date);
    },

    /**
     * Muestra un mensaje de error en un toast.
     * @param {string} message Mensaje a mostrar.
     * @returns {void}
     */
    showError(message) {
      if (!this.$swal) return;
      this.$swal.fire({
        icon: "error",
        title: "Error",
        text: message,
        position: "top-end",
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
      });
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      payments: "payment/payments",
    }),
    /**
     * Mapa de columnas a campos del backend, expuesto al template para
     * resaltar el icono de la columna actualmente ordenada.
     * @returns {Readonly<Record<string, string>>}
     */
    COLUMN_TO_BACKEND() {
      return COLUMN_TO_BACKEND;
    },
    /**
     * Total de páginas calculadas por el backend.
     * @returns {number}
     */
    totalPages() {
      return this.payments.total_pages || 1;
    },
    wrappedTableHeaders() {
      return this.tableHeaders;
    },
    date_start_formatted: {
      get() {
        if (this.filters.date_start) {
          return moment(this.filters.date_start).format("DD/MM/YYYY");
        }
        return null;
      },
      set(value) {
        if (!value) {
          this.filters.date_start = null;
          return;
        }
        const parsed = moment(value, "DD/MM/YYYY", true);
        this.filters.date_start = parsed.isValid() ? parsed.toDate() : null;
      },
    },
    date_end_formatted: {
      get() {
        if (this.filters.date_end) {
          return moment(this.filters.date_end).format("DD/MM/YYYY");
        }
        return null;
      },
      set(value) {
        if (!value) {
          this.filters.date_end = null;
          return;
        }
        const parsed = moment(value, "DD/MM/YYYY", true);
        this.filters.date_end = parsed.isValid() ? parsed.toDate() : null;
      },
    },
  },
  watch: {
    "filters.page"(newValue) {
      this.getPaymentsData({ page: newValue });
    },
    "filters.items"() {
      this.filters.page = 1;
      this.getPaymentsData();
    },
    "filters.is_paid"() {
      this.filters.page = 1;
      this.getPaymentsData();
    },
    "filters.filter"() {
      this.filters.page = 1;
      this.getPaymentsData({ debounced: true });
    },
    "filters.date_start"() {
      this.filters.page = 1;
      this.getPaymentsData();
    },
    "filters.date_end"() {
      this.filters.page = 1;
      this.getPaymentsData();
    },
  },
};
</script>